import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import * as React from 'react';
export default {
  SwaggerUI,
  React
};